export const MAX_NUM_ENTRIES = 10;
export const PAYMENTS_PER_YEAR = 26;
export const MONTHS_PER_YEAR = 12;
